module.exports = __webpack_public_path__ + "img/BS28.afb8c218.svg";